import { Compass } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import { Link } from "react-router-dom";

const COLUMNS = [
  {
    title: "Get started",
    links: [
      { label: "Assessment", to: "/register", testid: "footer-assessment-link" },
      { label: "Pricing", href: "/#pricing", testid: "footer-pricing-link" },
      { label: "How it works", href: "/#how-it-works", testid: "footer-how-it-works-link" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about", testid: "footer-about-link" },
      { label: "FAQ", to: "/faq", testid: "footer-faq-link" },
      { label: "Contact", to: "/contact", testid: "footer-contact-link" },
    ],
  },
  {
    title: "Account",
    links: [
      { label: "Log in", to: "/login", testid: "footer-login-link" },
      { label: "Register", to: "/register", testid: "footer-register-link" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy", to: "/privacy", testid: "footer-privacy-link" },
      { label: "Terms", to: "/terms", testid: "footer-terms-link" },
      { label: "Disclaimer", to: "/disclaimer", testid: "footer-disclaimer-link" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      className="bg-slate-50 border-t border-slate-200"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div>
            <a
              href="/"
              className="flex items-center gap-2 text-slate-900"
              data-testid="footer-brand-link"
            >
              <BrandLogo size="md" tone="light" testid="footer-brand-logo" />
              <span className="font-medium tracking-tight text-base">
                The AI Took My Job
              </span>
            </a>
            <p className="mt-4 text-sm text-slate-500 leading-relaxed max-w-xs">
              {"A calm, practical guide for figuring out what's next when the work you knew is changing."}
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-medium text-slate-900 mb-4">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.to || l.href}>
                    {l.to ? (
                      <Link
                        to={l.to}
                        className="text-sm text-slate-500 hover:text-slate-900 transition-colors"
                        data-testid={l.testid}
                      >
                        {l.label}
                      </Link>
                    ) : (
                      <a
                        href={l.href}
                        className="text-sm text-slate-500 hover:text-slate-900 transition-colors"
                        data-testid={l.testid}
                      >
                        {l.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-slate-500" data-testid="footer-copy">
            © {new Date().getFullYear()} The AI Took My Job. All rights reserved.
          </p>
          <p className="text-xs text-slate-400">
            {"Built with care for people navigating change."}
          </p>
        </div>
      </div>
    </footer>
  );
}
